import { IReverseButton } from "@/shared/interfaces/ReUsedComponentsProps";

import "./ReverseButton.scss";

export default function ReverseButton({ onClick }: IReverseButton) {
    return <button className='reverse_button' onClick={onClick} />;
}
